
<template>
  
  <div id="app" style="height:100%" v-show="firstLoad">
    
    <component :is="layout">
      <router-view/>
    </component >
  
    <app-alert/>
  </div>

</template>

<script>

import AuthLayout from './layouts/AuthLayout.vue'
import AppLayout from './layouts/AppLayout.vue'
import PdvLayout from './layouts/PdvLayout.vue'
import PrintLayout from './layouts/PrintLayout.vue'

export default {
  
  components : { AuthLayout, AppLayout, PdvLayout, PrintLayout },
  
  
  mounted() {
    this.isVisible = true
  },

  computed: {

    layout() {
      return this.$route.meta.layout
    },

    firstLoad() {
       return this.$store.state.firstLoad 
    }

  },
}
</script>
<style lang="scss">
  
  @import './assets/styles/custom.scss';
  @import './assets/styles/print.css';
  @import '../node_modules/bootstrap/scss/bootstrap.scss';
  @import './assets/styles/gridTable.scss';
  @import './assets/styles/fontawesome/css/all.min.css';
  
  @import './assets/styles/tables.css';

  @import url("https://fonts.googleapis.com/css?family=Nunito&display=swap");


  body {

    font-family: 'Nunito', sans-serif;

  }
</style>
